import React from 'react';
import { Button } from '@bedrock/components';
import AmountOrder from '@mpc/common/src/components/AmountOrder';
import DotDotDot from "@mpc/common/src/components/DotDotDot";
import { BiddingProcessStageEnum, outBiddingWorkbenchesList, outsourceCommonFilterOptions } from 'services/api';
import MPCList, { MPCListProps } from '@mpc/common/src/features/MPCList/index';
import { FILTER_OPTIONS } from './utils';
import { getCopyNode } from '@mpc/common/src/features/MPCList/utils';
import styles from './index.less';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface Props {
  bidding_process_stage: BiddingProcessStageEnum;
}

const List: React.FC<Props> = ({ bidding_process_stage }) => {
  const tableRef = React.useRef();

  const columnsConfig = {
    id: {
      fixed: 'left',
      width: 96,
      render: (v: any, r: any) => {
        return getCopyNode(v, <Button type='link'>{v}</Button>);
      },
    },
    product_identifier: {
      width: 104,
      align: 'left',
    },
    name: {
      width: 240,
      align: 'left',
      render: (v) => <DotDotDot clamp={1}>{v || '-'}</DotDotDot>,
    },
    budget_text: {
      width: 200,
      align: 'right',
      render: v => (
        <div className={cx('budge-text-box')}>
          <div className={cx('budge-text')}>{v}</div> 
            <div className={cx('amount')}>
             <AmountOrder value={v?.split(' ')[0]} />
            </div>
        </div>
      )
    },
    bidding_method: {
      width: 120,
      align: 'left',
    },
    bidding_type: {
      width: 160,
      align: 'left',
    },
    businesses_names: {
      align: 'left',
      width: 160,
      render: (v: any, r: any) => {
        const text = Array.isArray(v) ? v.join('，') : v;
        return <DotDotDot clamp={1}>{text || '-'}</DotDotDot>
      },
    },
    bidding_state_text: {
      width: 200,
      align: 'left',
    },
    operation: {
      width: 60,
      fixed: 'right',
      render: (v: any, r: any) => {
        return (r['can_move?'] || r['can_move']) &&
          (r['state'] || '').toLowerCase() !== 'closed' && <Button type='link'>处理</Button>
      }
    },
  }

  const fetchFilterOptions = () => outsourceCommonFilterOptions({
    keys: FILTER_OPTIONS.filterKeys,
    group_type: "CHANNEL_GROUP",
  })

  const fetchList: MPCListProps['fetchList'] = (params) => {
    return outBiddingWorkbenchesList({
      ...params,
      size: params.pageSize,
      bidding_process_stage
    })
  }

  return (
    <MPCList
      fetchList={fetchList}
      ref={tableRef}
      filterOptions={FILTER_OPTIONS}
      customColumnsConf={columnsConfig}
      fetchFilterOptions={fetchFilterOptions}
      contentClassName="pd-l-16 pd-r-16"
    />
  )
}

export default List;